// Exports the "link" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('hugerte/plugins/link')
//   ES2015:
//     import 'hugerte/plugins/link'
require('./plugin.js');